import { useState } from 'react';
import { Switch, Box, Typography, Tooltip } from '@mui/material';

export default function SwitchYesNoBox({checked, setChecked, disabled, tooltiplabel, ...rest}) {

    const switchComponent = (
        <Switch
            checked={disabled ? false : checked}
            disabled={disabled}
            onChange={(e) => setChecked(e.target.checked)}
            sx={{
                transform: 'scaleX(-1)',
                '& .MuiSwitch-track': {
                    backgroundColor: (!checked || disabled) ? '#ccc' : '#1976d2',
                    opacity: 1,
                },
                '& .Mui-checked + .MuiSwitch-track': {
                    backgroundColor: '#1976d2',
                },
                '& .Mui-disabled + .MuiSwitch-track': {
                    backgroundColor: '#ccc',
                    opacity: 1,
                },
                '& .MuiSwitch-thumb': {
                    backgroundColor: (disabled || !checked) ? 'white' : 'var(--link-normal-color)',
                },
            }}
        />
    );

    return (
        <Box className="flex flex-row gap-1 p-1 text-xs items-center" data-testid={rest['data-testid']}>
            <div>YES</div>
            {tooltiplabel ? (
                <Tooltip title={tooltiplabel} placement="bottom" componentsProps={{tooltip: {
                            className: '!bg-main-normal color-white font-bold text-m',
                        }}}>
                    {<span>
          {switchComponent}
        </span>}
                </Tooltip>
            ) : (
                switchComponent
            )}
            <div>NO</div>
        </Box>
    );
}